import { QIcon_fire } from '@repo/icons/index'
import { useState } from 'react'
import { APP_SCREEN_NAME } from '../../../modules/hooks/common/appRouterVars'
import useAppRouter from '../../../modules/hooks/common/useAppRouter'
import useIsMobile from '../../../modules/hooks/common/useIsMobile'
import useReturnFullUrl from '../../../modules/hooks/webview/common/useReturnFullUrl'
import { n_caf } from '../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../modules/i18n/useTranslation'
import urls from '../../../modules/urls'
import { COLORS } from '../../../modules/vars'
import MessageCard, { MESSAGE_CARD_SIZE } from '../MessageCard'

interface ILessonEncouragementBoxProps {
  page: 'review' | 'statistic'
  popupType: number // 1부터
  onClose?: (e: React.MouseEvent<HTMLButtonElement>) => void
}

const LessonEncouragementBox = ({ page, popupType, onClose = () => {} }: ILessonEncouragementBoxProps) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(true)
  const getFullUrl = useReturnFullUrl()
  const router = useAppRouter()
  const isMobile = useIsMobile()

  const messageIndex = popupType >= 1 ? popupType : 1

  const handleClickBookLesson = () => {
    router.push(urls.student.newPortal.lessons.schedule, {
      appScreenName: APP_SCREEN_NAME.STACK_SCREEN,
      appSendData: {
        url: getFullUrl(urls.webview.lessons.schedule),
      },
    })
  }

  if (!open) return null
  return (
    <>
      <div className={page === 'review' ? 'flex lg:hidden' : 'flex md:hidden'}>
        <MessageCard
          bgColor={COLORS.RED50}
          size={MESSAGE_CARD_SIZE.SM}
          icon={<QIcon_fire color={COLORS.RED400} width={24} height={24} />}
          title={t(n_caf.overview.book_lesson_title['msg' + messageIndex])}
          description={t(n_caf.overview.book_lesson_body['msg' + messageIndex])}
          zIndex={2}
          onClickClose={(e) => {
            e.preventDefault()
            e.stopPropagation()
            onClose && onClose(e)
            setOpen(false)
          }}
          buttonTitle={t(n_caf.overview.book_lesson.btn)}
          buttonColor={COLORS.RED600}
          onClickButton={handleClickBookLesson}
          showMobileButton={true}
        />
      </div>
      <div className={page === 'review' ? 'hidden lg:flex' : 'hidden md:flex'}>
        <MessageCard
          bgColor={COLORS.RED50}
          size={MESSAGE_CARD_SIZE.LG}
          icon={<QIcon_fire color={COLORS.RED400} width={24} height={24} />}
          title={t(n_caf.overview.book_lesson_title['msg' + messageIndex])}
          description={t(n_caf.overview.book_lesson_body['msg' + messageIndex])}
          zIndex={2}
          onClickClose={(e) => {
            e.preventDefault()
            e.stopPropagation()
            onClose && onClose(e)
            setOpen(false)
          }}
          buttonTitle={t(n_caf.overview.book_lesson.btn)}
          buttonColor={COLORS.RED600}
          onClickButton={handleClickBookLesson}
          showMobileButton={true}
        />
      </div>
    </>
  )
}

export default LessonEncouragementBox
